import { AuthSource } from './AuthSource.ts';

const AuthGlobalOptions = {
  /**
   * Se impostato a true, l'utente verrà reindirizzato alla pagina di selezione
   * del ruolo dopo il login.
   */
  requiresRoleSelection: false,
  /**
   * Permette di personalizzare la chiave di Storage per l'utente corrente.
   */
  storageKey: 'fwpauth',
  /**
   * Imposta la sorgente di autenticazione predefinita.
   */
  source: AuthSource.Admin as AuthSource,
};

export function getAuthGlobalOptions() {
  return AuthGlobalOptions;
}

/**
 * Imposta le opzioni globali per il modulo Auth.
 */
export function setAuthGlobalOptions(
  options: Partial<typeof AuthGlobalOptions>,
) {
  Object.assign(AuthGlobalOptions, options);
}
